<template>
  <div class="grid-from-box">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="grid-from-box_item"
      data-animation="fade-scale-up"
      data-once="false"
    >
      <img :src="item.imgUrl" />
      <div class="grid-from-box_item-content">
        <div>{{ item.title }}</div>
        {{ item.descr }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.grid-from-box {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 两列等分 */
  column-gap: 30px; /* 列间距 30px */
  /* row-gap: 也可以设置行间距 */
  row-gap: 30px;
  .grid-from-box_item {
    display: flex;
    align-items: center;
    // gap: 15px;
    height: 160px;
    padding: 0 30px 0 30px;
    background: #f7f8fa;
    border-radius: 20px;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    z-index: 1;

    &:hover {
      transform: translateY(-8px) !important;
      // box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
      z-index: 2 !important;
    }

    img {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
      object-fit: cover;
      border-radius: 8px; /* 可选 */
    }
    .grid-from-box_item-content {
      flex: 1;
      font-size: 14px;
      color: #3d3d40;
      line-height: 24px;
      display: flex;
      text-align: left;
      flex-direction: column;
      margin-left: 20px;
      div {
        font-size: 24px;
        margin-bottom: 10px;
        color: #222226;
        line-height: 32px;
        font-family: 'MiSans-Demibold';
      }
    }
  }
}
</style>
